<page-grid [gridConfig]="vendorBalanceGrid" (gridClickColumn)="openBalanceDetail($event)"/>
